module.exports = __webpack_public_path__ + "img/logo_white_ru.de84ea53.png";